import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './containers/App/App';
import {BrowserRouter} from "react-router-dom";
import {AppStoreProvider} from './components/Mall/AppStore/AppStore';
import {ExceedApiProvider} from './containers/App/ExceedApi.js';
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';

import * as serviceWorker from './serviceWorker';

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

Sentry.init({
    dsn: "https://8db5b498cc884d5fbaa52b7115149cd4@o141913.ingest.sentry.io/5607579",
    release: "exceed-mobile@" + process.env.npm_package_version,
    autoSessionTracking: true,
    environment: (process.env.REACT_APP_API_BASE_ROUTE.split("//")[1]),
    integrations: [
        new Integrations.BrowserTracing(),
    ],
});

ReactDOM.render(<BrowserRouter><AppStoreProvider><ExceedApiProvider><App/></ExceedApiProvider></AppStoreProvider></BrowserRouter>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
